import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {MatchmakingCancelReason} from '../../../../shared/matchmaking/MatchmakingEnums.ts'
import {type MatchmakingStatusUpdate} from '../../../../shared/matchmaking/MatchmakingInterfaces.ts'
import {SocketMatchmakingSend} from '../../../shared/scripts/socket/SocketMatchmakingSend.ts'
import {createSpanIn, setElementInnerHTML, setElementInnerText, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {getNestedTranslation, type TranslationObject} from '@colonist/i18n'

export class UIMatchmakingSearchMatchPopupView {
    private readonly container: HTMLDivElement
    private readonly title: HTMLHeadingElement
    private readonly text: HTMLParagraphElement
    private readonly cancelButton: HTMLDivElement

    constructor() {
        this.container = document.getElementById('matchmaking-searchmatch-popup') as HTMLDivElement
        this.title = document.getElementById('matchmaking-searchmatch-title') as HTMLHeadingElement
        this.text = document.getElementById('matchmaking_searchmatch_text') as HTMLParagraphElement
        this.cancelButton = document.getElementById('matchmaking_searchmatch_cancelbutton') as HTMLDivElement

        this.setCancelAction()
    }

    update(matchmakingStatusUpdate: MatchmakingStatusUpdate, primaryMatchType: MatchmakingMatchTypes) {
        if(!this.isShowing()) {
            const gameModeText = UIMatchmakingSearchMatchPopupView.getGameModeText(primaryMatchType)
            const popupTitle = getNestedTranslation({key: 'strings:homePage.matchmakingPopup.searchingForGame'}, {gameMode: gameModeText})
            setElementInnerText(this.title, popupTitle)

            this.show()
        }

        const isModeRanked = primaryMatchType == MatchmakingMatchTypes.RankedClassic1v1 || primaryMatchType == MatchmakingMatchTypes.RankedClassic4P || primaryMatchType == MatchmakingMatchTypes.RankedCitiesAndKnights4P || primaryMatchType == MatchmakingMatchTypes.RankedRush4P
        const isModeShuffle = primaryMatchType == MatchmakingMatchTypes.UnrankedShuffle
        const context = isModeRanked ? 'ranked' : (isModeShuffle ? 'shuffle' : undefined)
        setElementInnerHTML(this.text, {key: 'strings:homePage.matchmakingSearch.lookingForPlayers', options: {context: context}})
        if(matchmakingStatusUpdate.totalNumberOfPlayersNeeded != undefined) createSpanIn(this.text, '', {key: 'strings:colonistCommon.utils.#buffer', options: {value: ` (${matchmakingStatusUpdate.numberOfPlayersFound}/${matchmakingStatusUpdate.totalNumberOfPlayersNeeded})`}})
    }

    private setCancelAction() {
        setElementOnClick(this.cancelButton, () => {
            SocketMatchmakingSend.sendCancelFindGame(MatchmakingCancelReason.ClickedCancel)
            this.hide()
        })
    }

    isShowing(): boolean {
        return this.container.style.display == 'block'
    }

    hide() {
        this.container.style.display = 'none'
    }

    private show() {
        this.container.style.display = 'block'
    }

    private static getGameModeText(matchType: MatchmakingMatchTypes): TranslationObject {
        switch(matchType) {
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P: return {key: 'strings:homePage.matchmakingPopup.rankedCitiesAndKnights.title'}
            case MatchmakingMatchTypes.RankedClassic1v1: return {key: 'strings:homePage.matchmakingPopup.ranked1v1.title'}
            case MatchmakingMatchTypes.RankedClassic4P: return {key: 'strings:homePage.matchmakingPopup.ranked4Player.title'}
            case MatchmakingMatchTypes.UnrankedClassic1v1: return {key: 'strings:homePage.matchmakingPopup.unranked1v1.title'}
            case MatchmakingMatchTypes.UnrankedClassic4P: return {key: 'strings:homePage.matchmakingPopup.unranked4Player.title'}
            case MatchmakingMatchTypes.RankedRush4P: return {key: 'strings:homePage.matchmakingPopup.rankedRush.title'}
            case MatchmakingMatchTypes.UnrankedShuffle: return {key: 'strings:homePage.matchmakingPopup.shuffle.title'}
            default: return {key: 'strings:colonistCommon.utils.emptyString'}
        }
    }
}
